import moment from 'moment';

import { Car, Visit, VisitTimeProposition } from '../models';

/* eslint-disable camelcase */
const convertCar = (car, car_ownership, finished, image) => {
  return new Car(
    car.id,
    car.make_name,
    car.model_name,
    car.variant,
    car.version,
    car.vin,
    car.production_year,
    car.fuel,
    car.engine_capacity,
    car.engine_power_kw,
    car.curb_weight,
    car.first_registration_date,
    car_ownership.car_nickname,
    car_ownership.color,
    car_ownership.owner_id,
    car_ownership.registration_number,
    car_ownership.id,
    finished,
    image,
  );
};

// eslint-disable-next-line import/prefer-default-export
export const convertWorkshopCalendarVisits = (visits) => {
  const convertedVisits = visits.map((data) => {
    const {
      id,
      car_ownership,
      workshop_ownership,
      scheduled_time,
      message_from_client,
      message_from_workshop,
      status,
      time_preference,
      time_proposition,
      car,
      initiated_by,
      payment_status,
    } = data?.resource;

    const convertedCar = convertCar(car, car_ownership);
    const timePropositions = time_proposition
      ? new VisitTimeProposition(
          id,
          time_proposition.first_proposition,
          time_proposition.second_proposition,
        )
      : null;

    const visit = new Visit(
      id,
      car_ownership,
      workshop_ownership,
      scheduled_time,
      message_from_client,
      message_from_workshop,
      status,
      time_preference,
      timePropositions,
      null,
      null,
      convertedCar,
      null,
      null,
      null,
      null,
      null,
      initiated_by,
      payment_status,
    );

    const convertedVisit = {
      start: moment(data?.start).toDate(),
      end: moment(data?.end).add(2, 'hours').toDate(),
      allDay: false,
      title: data?.title,
      resource: visit,
    };
    return convertedVisit;
  });

  return convertedVisits;
};
